import { heroui } from "@heroui/react";

export default heroui({
  prefix: "heroui",
  addCommonColors: true,
  defaultTheme: "light",
  defaultExtendTheme: "light",
  layout: {},
  themes: {
    light: {
      layout: {},
      colors: {
        primary: {
          DEFAULT: "#ffffff",
          foreground: "#3b82f6",
        },
        secondary: {
          DEFAULT: "#93c5fd",
          foreground: "#1e3a8a",
        },
        success: {
          DEFAULT: "#17c964",
          foreground: "#ffffff",
        },
        warning: {
          DEFAULT: "#f5a524",
          foreground: "#ffffff",
        },
        danger: {
          DEFAULT: "#ef4444",
          foreground: "#ffffff",
        },
      },
    },
    dark: {
      layout: {},
      colors: {
        primary: {
          DEFAULT: "#34d399",
          foreground: "#ffffff",
        },
        secondary: {
          DEFAULT: "#3b82f6",
          foreground: "#dbeafe",
        },
        success: {
          DEFAULT: "#17c964",
          foreground: "#ffffff",
        },
        warning: {
          DEFAULT: "#f5a524",
          foreground: "#ffffff",
        },
        danger: {
          DEFAULT: "#f87171",
          foreground: "#ffffff",
        },
      },
    },
  },
});